import { Navigate, type RouteObject } from 'react-router-dom'
import AppLayout from './components/AppLayout/AppLayout'
import { SettingsPage } from './pages/SettingsPage'
import { WorkOrdersPage } from './pages/WorkOrdersPage'
import { ReleaseHistoryPage } from '../pages/ReleaseHistoryPage/ReleaseHistoryPage'

/**
 * Route tree mounted at the application root when the audience selector
 * is set to technician. Floor Copilot pages (Today / Lines / SOPs / Handoff)
 * are replaced by the work-order inbox (AXI-4564).
 *
 * Chat app-context (AXI-4791): when adding/renaming a path here, also update
 * `chat-app-context/routePathTrees.ts` (operatorPathTree) and
 * `chat-app-context/pageContextRegistry.ts` (PAGE_CONTEXT_BY_PATH).
 */
const operatorRoutes: RouteObject[] = [
  {
    element: <AppLayout />,
    children: [
      { index: true, element: <WorkOrdersPage /> },
      { path: 'work-orders/:id', element: <WorkOrdersPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'releases', element: <ReleaseHistoryPage /> },
      // Old Floor Copilot deep links → work-order inbox
      { path: 'equipment', element: <Navigate replace to="/" /> },
      { path: 'procedures', element: <Navigate replace to="/" /> },
      { path: 'procedures/:alarmId', element: <Navigate replace to="/" /> },
      { path: 'handoff', element: <Navigate replace to="/" /> },
      { path: '*', element: <Navigate replace to="/" /> }
    ]
  }
]

export default operatorRoutes
